import { useCallback, useRef } from 'react'
import AppStore from '@v4/store/appStore'
import { useSectionActions, useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './EditableContainer.styled'

export const useEditableContainer = props => {
	const {
		children,
		fieldConfig,
		visible,
		editable,
		label,
		onAdd,
		className,
		wrapper,
		white = false,
		shadow = false,
		withoutBanner = false,
		defaultValue = '​',
	} = props
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const { visible: actionsVisible } = useSectionActions()
	const classes = useStyles({ ...props, white, shadow, withoutBanner })
	const sectionId = useSectionId()
	const activeSectionId = PageBuilderSelector.useActiveSectionId()
	const rootRef = useRef()
	const handleAdd = useCallback(
		event => {
			event.preventDefault()
			event.stopPropagation()
			const parentElement = rootRef.current?.parentElement
			const htmlContent = defaultValue

			onAdd?.(htmlContent)

			setTimeout(() => {
				const textElements = parentElement?.querySelectorAll('[id^="mce"]')
				const tempEl = document.createElement('div')
				tempEl.innerHTML = htmlContent
				const textContent = tempEl.innerText.replace(/[^a-zA-Z0-9]+/g, '')
				const textEl = _.find(textElements, el => el.innerText.replace(/[^a-zA-Z0-9]+/g, '') === textContent)
				textEl?.focus()
				try {
					const range = document.createRange()
					const sel = window.getSelection()
					range.setStart(textEl, textEl.childNodes.length)
					range.collapse(true)
					sel.removeAllRanges()
					sel.addRange(range)
					// eslint-disable-next-line no-empty
				} catch (e) {}
			}, 300)
		},
		[defaultValue, onAdd],
	)

	return [
		{
			rootRef,
			className,
			children,
			classes,
			visible: visible || (withoutBanner && isBuilderMode && editable),
			isBannerActive:
				!withoutBanner &&
				actionsVisible &&
				isBuilderMode &&
				!visible &&
				!!fieldConfig &&
				editable &&
				sectionId === activeSectionId,
			label: `Add ${label || fieldConfig?.display || 'item'}`,
			wrapper,
		},
		{
			handleAdd,
		},
	]
}
